
(function() {
  'use strict';

  // CONFIGURAZIONE
  const CONFIG = {
    storageKey: 'fx-recently-viewed-products',
    maxProducts: null, // Nessun limite
    debug: false
  };

  // STATO GLOBALE
  let storeProducts = {};
  let recentlyViewed = [];

  // UTILITY: Log
  function log(...args) {
    if (CONFIG.debug) {
    }
  }

  // INIZIALIZZAZIONE
  function init() {
    log('Inizializzazione...');

    loadStoreData();
    loadFromStorage();
    autoTrackCurrentProduct();
    render();
    bindEvents();
    initGlobalTracking();
    initWishlist();

    log('Inizializzato con', recentlyViewed.length, 'prodotti');
  }

  // CARICA DATI STORE
  function loadStoreData() {
    try {
      const script = document.getElementById('recentlyViewedStoreData');
      if (script) {
        const data = JSON.parse(script.textContent);
        storeProducts = data.products || {};
        log('Store caricato:', Object.keys(storeProducts).length, 'prodotti');
      }
    } catch (error) {
      log('Errore caricamento store:', error);
    }
  }

  // CARICA DA LOCALSTORAGE
  function loadFromStorage() {
    try {
      const stored = localStorage.getItem(CONFIG.storageKey);
      const handles = stored ? JSON.parse(stored) : [];

      recentlyViewed = handles
        .map(handle => storeProducts[handle])
        .filter(product => product);

      log('Caricati da storage:', recentlyViewed.length, 'prodotti');
    } catch (error) {
      log('Errore caricamento storage:', error);
      recentlyViewed = [];
    }
  }

  // SALVA IN LOCALSTORAGE
  function saveToStorage() {
    try {
      const handles = recentlyViewed.map(p => p.handle);
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(handles));
      log('Salvato in storage:', handles.length, 'prodotti');
      return true;
    } catch (error) {
      log('Errore salvataggio:', error);
      return false;
    }
  }

  // AUTO-TRACK PRODOTTO CORRENTE
  function autoTrackCurrentProduct() {
    const section = document.querySelector('[data-section-type="fx-recently-viewed"]');
    if (section) {
      const settings = section.dataset.sectionSettings;
      if (settings) {
        try {
          const parsedSettings = JSON.parse(settings);
          if (parsedSettings.currentProduct) {
            log('Prodotto corrente:', parsedSettings.currentProduct);
            addProduct(parsedSettings.currentProduct);
            return;
          }
        } catch (error) {
          log('Errore parsing settings:', error);
        }
      }
    }

    // Fallback: URL
    const pathParts = window.location.pathname.split('/');
    const productIndex = pathParts.indexOf('products');

    if (productIndex !== -1 && pathParts[productIndex + 1]) {
      const handle = pathParts[productIndex + 1].split('?')[0];
      log('Prodotto da URL:', handle);
      addProduct(handle);

      setTimeout(() => addProduct(handle), 1000);
    }
  }

  // TRACCIAMENTO GLOBALE LINK
  function initGlobalTracking() {
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a[href*="/products/"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      const match = href.match(/\/products\/([^\/\?#]+)/);
      if (match && match[1]) {
        const handle = match[1];
        if (storeProducts[handle]) {
          addProduct(handle);
        }
      }
    });

    log('Tracciamento globale attivato');
  }

  // AGGIUNGI PRODOTTO
  function addProduct(handle) {
    if (!handle || typeof handle !== 'string') return false;

    handle = handle.trim();

    if (!storeProducts[handle]) {
      log('Prodotto non trovato:', handle);
      return false;
    }

    const product = storeProducts[handle];

    // Rimuovi se già presente
    recentlyViewed = recentlyViewed.filter(p => p.handle !== handle);

    // Aggiungi in cima
    recentlyViewed.unshift(product);

    saveToStorage();
    render();

    log('Prodotto aggiunto:', product.title);
    return true;
  }

  // RIMUOVI PRODOTTO
  function removeProduct(handle) {
    const product = recentlyViewed.find(p => p.handle === handle);
    if (!product) return false;

    showConfirmModal(
      'Rimuovi dalle visualizzazioni',
      `Vuoi rimuovere "<strong>${product.title}</strong>" dalle visualizzazioni recenti?`,
      () => {
        recentlyViewed = recentlyViewed.filter(p => p.handle !== handle);
        saveToStorage();
        render();
        showNotification('Prodotto rimosso', 'info');
        log('Prodotto rimosso:', handle);
      }
    );

    return true;
  }

  // SVUOTA TUTTO
  function clearAll() {
    if (recentlyViewed.length === 0) return;

    showConfirmModal(
      'Conferma eliminazione',
      `Sei sicuro di voler svuotare le tue visualizzazioni recenti? Verranno rimossi <strong>${recentlyViewed.length} prodotti</strong>.`,
      () => {
        recentlyViewed = [];
        saveToStorage();
        render();
        showNotification('Visualizzazioni svuotate', 'info');
        log('Visualizzazioni svuotate');
      }
    );
  }

  // RENDER
  function render() {
    const carousel = document.getElementById('fx-recently-viewed-carousel');
    const emptyState = document.getElementById('recentlyViewedEmpty');
    const actions = document.getElementById('recentlyViewedActions');

    if (!carousel || !emptyState) return;

    if (recentlyViewed.length === 0) {
      carousel.style.display = 'none';
      emptyState.classList.add('active');
      if (actions) actions.classList.remove('active');
      var _rvSec0 = document.querySelector('[data-section-type="fx-recently-viewed"]');
      if (_rvSec0) _rvSec0.style.display = 'none';
      return;
    }

    var _rvSec1 = document.querySelector('[data-section-type="fx-recently-viewed"]');
    if (_rvSec1) _rvSec1.style.display = '';
    carousel.style.display = 'flex';
    emptyState.classList.remove('active');
    if (actions) actions.classList.add('active');

    // Pulisci carousel
    carousel.innerHTML = '';

    // Crea cards
    recentlyViewed.forEach(product => {
      const card = createCard(product);
      carousel.appendChild(card);
    });

    // Inizializza navigation
    setTimeout(() => {
      initNavigation();
      initWishlist();

      // 🔥 FORZA SCROLL ORIZZONTALE SU MOBILE
      if (window.innerWidth <= 749) {
        forceHorizontalScroll();
      }
    }, 100);

    log('Render completato:', recentlyViewed.length, 'prodotti');
  }

  // CREA CARD (STILE FEATURED V2 — identico a card effetti)
  const _rvFmt = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });
  function createCard(product) {
    const cell = document.createElement('div');
    cell.className = 'fx-recently-viewed-cell';

    const formatPrice = (price) => _rvFmt.format(price / 100);

    // Usa prezzi al mq da Shopify (unit_price) (come le card effetti)
    let displayPrice = product.price;
    let displayCompare = product.compare_at_price;
    let isTile = false;
    const pType = (product.type || '').toLowerCase();
    const pVendor = (product.vendor || '').toLowerCase();
    if (pType.includes('piastrelle') || pType.includes('ceramica') || pType.includes('gres') || pType.includes('tiles') ||
        pVendor.includes('ceramica euro') || pVendor.includes('florim') || pVendor.includes('tagina') ||
        pVendor.includes('herberia') || pVendor.includes('supergres') || pVendor.includes('italgraniti') ||
        pVendor.includes('la faenza') || pVendor.includes('leonardo')) {
      isTile = true;
    }
    if (isTile && window.getPrezzoMinimoM2) {
      try {
        const fisso = window.getPrezzoMinimoM2(product.title);
        if (fisso) {
          displayPrice = fisso.prezzo;
          displayCompare = fisso.comparePrice;
        }
      } catch(e) {}
    }

    const discount = displayCompare > displayPrice ?
      Math.round(((displayCompare - displayPrice) / displayCompare) * 100) : 0;

    const priceHtml = isTile ?
      formatPrice(displayPrice) + '<span style="font-size:1em;color:inherit;font-weight:inherit;">/</span><span style="font-size:0.9em;color:inherit;">mq</span>' :
      formatPrice(displayPrice);

    cell.innerHTML = `
      <div class="fx-product-standard-card">
        <a href="${product.url}">
          <div class="fx-card-image-container">
            ${product.image ? `
              <img class="fx-card-image-primary CardImage--primary" src="${product.image}" alt="${product.title}" loading="lazy" decoding="async">
              ${product.second_image ? `
                <img class="fx-card-image-secondary CardImage--secondary" src="${product.second_image}" alt="${product.title}" loading="lazy" decoding="async">
              ` : ''}
            ` : '<div style="width:100%;height:100%;background:#F5F2EB;"></div>'}

            <div class="fx-product-remove-container">
              <button class="fx-remove-btn" data-handle="${product.handle}" title="Rimuovi">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 6h18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </button>
            </div>

            <div class="fx-product-wishlist-container">
              <button class="fx-wishlist-btn"
                      data-product-handle="${product.handle}"
                      data-product-title="${product.title}"
                      data-product-url="${product.url}"
                      data-product-image="${product.image || ''}"
                      data-product-price="${product.price}"
                      aria-label="Aggiungi alla wishlist">
                <svg class="fx-wishlist-icon" width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="fx-product-card-content">
            <h5 class="fx-product-title">${product.title}</h5>

            <div class="fx-price-container" data-product-type="${product.type || ''}" data-product-vendor="${product.vendor || ''}" data-product-handle="${product.handle}">
              ${product.price_varies ? '<span class="fx-starting-from">A PARTIRE DA</span>' : ''}
              <div class="fx-price-row">
                <span class="fx-price" data-price="${displayPrice}">${priceHtml}</span>
                ${displayCompare > displayPrice ? `
                  <span class="fx-original-price" data-compare-price="${displayCompare}">${formatPrice(displayCompare)}</span>
                  
                ` : ''}
              </div>
              <div class="ProductCard__BoxPrice fx-box-price">${isTile ? (formatPrice(product.box_price_min > 0 ? product.box_price_min : product.price) + '/scatola <span class="fx-box-separator">&middot;</span> IVA incl.') : 'IVA incl.'}</div>
              ${!product.available ? '<span class="fx-soldout-badge">Esaurito</span>' : ''}
            </div>
          </div>
        </a>
      </div>
    `;

    return cell;
  }

  // INIZIALIZZA NAVIGATION
  function initNavigation() {
    const carousel = document.getElementById('fx-recently-viewed-carousel');
    const dotsContainer = document.getElementById('fx-recently-viewed-dots');
    const prevBtn = document.getElementById('fx-recently-viewed-prev');
    const nextBtn = document.getElementById('fx-recently-viewed-next');

    if (!carousel) return;

    const cards = carousel.querySelectorAll('.fx-recently-viewed-cell');
    if (cards.length === 0) return;

    const isMobile = window.innerWidth <= 749;
    const cardWidth = isMobile ? 250 : 280;
    const gap = 24; // 1.5rem
    let currentIndex = 0;
    const maxIndex = cards.length - 1;

    // Crea dots - UNO PER OGNI PRODOTTO
    function createDots() {
      dotsContainer.innerHTML = '';
      for (let i = 0; i < cards.length; i++) {
        const dot = document.createElement('button');
        dot.classList.add('fx-recently-viewed-dot');
        if (i === 0) dot.classList.add('active');
        dot.addEventListener('click', () => scrollToCard(i));
        dotsContainer.appendChild(dot);
      }
    }

    // Aggiorna dots attivo
    function updateDots(index) {
      const dots = dotsContainer.querySelectorAll('.fx-recently-viewed-dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    // Scroll a una card specifica
    function scrollToCard(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      const card = cards[currentIndex];
      if (card) {
        const cardLeft = card.offsetLeft;
        const isMobile = window.innerWidth <= 749;

        let scrollPosition;

        if (isMobile) {
          // Su mobile: centra sempre la card
          scrollPosition = cardLeft - (carousel.offsetWidth / 2) + (cardWidth / 2);
        } else {
          // Su desktop: allineamento intelligente
          if (currentIndex === 0) {
            // Prima card: allinea a sinistra (rimuovi padding)
            scrollPosition = 0;
          } else if (currentIndex === maxIndex) {
            // Ultima card: allinea a destra
            scrollPosition = carousel.scrollWidth - carousel.offsetWidth;
          } else {
            // Card intermedie: centra
            scrollPosition = cardLeft - (carousel.offsetWidth / 2) + (cardWidth / 2);
          }
        }

        carousel.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
      updateDots(currentIndex);
    }

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollToCard(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollToCard(currentIndex + 1);
      });
    }

    // Scroll listener - RILEVA CARD AL CENTRO
    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      const carouselCenter = scrollLeft + (carousel.offsetWidth / 2);

      // Trova quale card è più vicina al centro
      let closestIndex = 0;
      let closestDistance = Infinity;

      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + (cardWidth / 2);
        const distance = Math.abs(carouselCenter - cardCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex !== currentIndex) {
        currentIndex = closestIndex;
      }
    });

    // Su desktop, inizia con la prima card allineata a sinistra
    if (window.innerWidth > 749) {
      carousel.scrollTo({ left: 0, behavior: 'auto' });
    }

    // Desktop: drag fluido
    if (window.innerWidth > 749) {
      var isDragging = false, wasDragged = false, dragStartX, dragScrollLeft;
      carousel.style.cursor = 'grab';

      carousel.addEventListener('mousedown', function(e) {
        isDragging = true;
        wasDragged = false;
        dragStartX = e.pageX;
        dragScrollLeft = carousel.scrollLeft;
        carousel.style.cursor = 'grabbing';
        carousel.style.scrollBehavior = 'auto';
        e.preventDefault();
      });

      document.addEventListener('mousemove', function(e) {
        if (!isDragging) return;
        if (Math.abs(e.pageX - dragStartX) > 5) wasDragged = true;
        carousel.scrollLeft = dragScrollLeft - (e.pageX - dragStartX);
      });

      document.addEventListener('mouseup', function() {
        if (!isDragging) return;
        isDragging = false;
        carousel.style.cursor = 'grab';
        carousel.style.scrollBehavior = '';
      });

      carousel.addEventListener('click', function(e) {
        if (wasDragged) {
          e.preventDefault();
          e.stopPropagation();
          wasDragged = false;
        }
      }, true);
    }
  }

  // 🔥 FORZA SCROLL ORIZZONTALE SU MOBILE - Bypassa touch-action del body
  function forceHorizontalScroll() {
    const carousel = document.getElementById('fx-recently-viewed-carousel');
    if (!carousel) {
      log('forceHorizontalScroll: carousel non trovato');
      return;
    }

    log('🔥 forceHorizontalScroll: Inizializzazione touch handler');

    // Forza stili inline
    carousel.style.setProperty('overflow-x', 'auto', 'important');
    carousel.style.setProperty('overflow-y', 'hidden', 'important');
    carousel.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    carousel.style.setProperty('overscroll-behavior-x', 'contain', 'important');
    carousel.style.setProperty('touch-action', 'pan-x pan-y', 'important');

    // Stili anche sulle celle
    const cells = carousel.querySelectorAll('.fx-recently-viewed-cell');
    cells.forEach(cell => {
      cell.style.setProperty('touch-action', 'pan-x pan-y', 'important');
    });

    // 🔥 TOUCH HANDLER MANUALE - Bypassa touch-action del body
    let startX = 0;
    let startY = 0;
    let startScrollLeft = 0;
    let isScrollingHorizontally = null;
    // KH-MOMENTUM 2026-10-07: inerzia (flick) come gli altri caroselli -> scorrimento fluido e veloce
    let rvLastX = 0, rvLastT = 0, rvVel = 0, rvRaf = 0;
    function rvStopInertia(){ if (rvRaf) { cancelAnimationFrame(rvRaf); rvRaf = 0; } }
    function rvInertia(){
      rvRaf = requestAnimationFrame(function(){
        var max = carousel.scrollWidth - carousel.clientWidth;
        carousel.scrollLeft += rvVel * 16; rvVel *= 0.95;
        if (carousel.scrollLeft <= 0 || carousel.scrollLeft >= max || Math.abs(rvVel) < 0.03) { rvRaf = 0; return; }
        rvInertia();
      });
    }

    carousel.addEventListener('touchstart', function(e) {
      rvStopInertia();
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startScrollLeft = carousel.scrollLeft;
      isScrollingHorizontally = null;
      rvLastX = startX; rvLastT = e.timeStamp; rvVel = 0;
    }, { passive: true });

    carousel.addEventListener('touchmove', function(e) {
      if (!startX) return;

      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const diffX = startX - currentX;
      const diffY = startY - currentY;

      // Determina direzione scroll (solo una volta per gesture)
      if (isScrollingHorizontally === null && (Math.abs(diffX) > 5 || Math.abs(diffY) > 5)) {
        isScrollingHorizontally = Math.abs(diffX) > Math.abs(diffY);
      }

      // Se scroll orizzontale, gestisci manualmente + traccia velocita'
      if (isScrollingHorizontally) {
        e.preventDefault();
        carousel.scrollLeft = startScrollLeft + diffX;
        var dt = e.timeStamp - rvLastT; if (dt > 0) { var v = (rvLastX - currentX) / dt; rvVel = rvVel * 0.4 + v * 0.6; }
        rvLastX = currentX; rvLastT = e.timeStamp;
      }
    }, { passive: false });

    carousel.addEventListener('touchend', function(e) {
      if (isScrollingHorizontally && Math.abs(rvVel) > 0.08) { if (rvVel > 2.5) rvVel = 2.5; if (rvVel < -2.5) rvVel = -2.5; rvInertia(); }
      startX = 0;
      startY = 0;
      isScrollingHorizontally = null;
    }, { passive: true });

    log('🔥 Touch handler configurato per recently viewed carousel');
  }

  // BIND EVENTS
  function bindEvents() {
    // Pulsanti rimozione - Event delegation
    document.addEventListener('click', function(e) {
      const removeBtn = e.target.closest('.fx-remove-btn');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = removeBtn.getAttribute('data-handle');
        if (handle) removeProduct(handle);
      }
    });

    // Pulsante svuota
    const clearBtn = document.getElementById('clearRecentlyViewedBtn');
    if (clearBtn) {
      clearBtn.addEventListener('click', clearAll);
    }

    log('Eventi collegati');
  }

  // MODALE CONFERMA
  function showConfirmModal(title, message, onConfirm) {
    const modal = document.createElement('div');
    modal.style.cssText = `
      position: fixed; inset: 0; z-index: 99999;
      background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(8px);
      display: flex; align-items: center; justify-content: center;
      padding: 2rem; animation: fadeIn 0.3s ease;
    `;

    modal.innerHTML = `
      <div style="
        background: rgba(255, 255, 255, 0.98); backdrop-filter: blur(20px);
        border-radius: 24px; padding: 2.5rem; max-width: 480px; width: 100%;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        border: 1px solid rgba(45, 90, 61, 0.2);
        animation: modalIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      ">
        <div style="text-align: center; margin-bottom: 2rem;">
          <div style="margin-bottom: 1.5rem;">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" style="color: #E12D2D;">
              <path d="M3 6h18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </div>
          <h3 style="margin: 0 0 1rem 0; color: #2d3436; font-size: 1.5rem; font-weight: 700;">${title}</h3>
          <p style="margin: 0; color: #636e72; font-size: 1.1rem; line-height: 1.5;">${message}</p>
        </div>

        <div style="display: flex; gap: 1rem; justify-content: center;">
          <button class="modal-cancel" style="
            flex: 1; padding: 1rem 1.5rem; border-radius: 16px; border: 2px solid #D9D2C5;
            background: white; color: #636e72; font-weight: 600; font-size: 0.95rem; cursor: pointer;
            transition: all 0.3s ease; min-height: 48px;
          ">
            Annulla
          </button>
          <button class="modal-confirm" style="
            flex: 1; padding: 1rem 1.5rem; border-radius: 16px; border: 2px solid #E12D2D;
            background: white; color: #E12D2D; font-weight: 600; font-size: 0.95rem; cursor: pointer;
            transition: all 0.3s ease; min-height: 48px;
          ">
            Conferma
          </button>
        </div>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes modalIn {
        from { opacity: 0; transform: scale(0.9) translateY(20px); }
        to { opacity: 1; transform: scale(1) translateY(0); }
      }
      .modal-cancel:hover {
        background: #F5F2EB !important;
        border-color: #2D5A3D !important;
        color: #2D5A3D !important;
        transform: translateY(-2px);
      }
      .modal-confirm:hover {
        background: #E12D2D !important;
        color: white !important;
        transform: translateY(-2px);
      }
    `;
    document.head.appendChild(style);

    document.body.appendChild(modal);

    modal.querySelector('.modal-cancel').addEventListener('click', () => {
      modal.remove();
      style.remove();
    });

    modal.querySelector('.modal-confirm').addEventListener('click', () => {
      modal.remove();
      style.remove();
      onConfirm();
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal && window.innerWidth > 768) {
        modal.remove();
        style.remove();
      }
    });
  }

  // NOTIFICA
  function showNotification(message, type = 'info') {
    // Rimuovi notifiche esistenti prima di mostrare la nuova
    const existingNotifications = document.querySelectorAll('.fx-notification');
    existingNotifications.forEach(notif => {
      notif.style.transform = 'translateX(100%)';
      notif.style.opacity = '0';
      setTimeout(() => notif.remove(), 400);
    });

    const notification = document.createElement('div');
    notification.className = `fx-notification ${type}`;

    const icons = {
      success: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="#2D5A3D" stroke="#2D5A3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      error: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" fill="#E12D2D" stroke="#E12D2D" stroke-width="2"/><path d="M15 9l-6 6" stroke="white" stroke-width="2"/><path d="M9 9l6 6" stroke="white" stroke-width="2"/></svg>',
      warning: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 9v4" stroke="#ffaa00" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="17" r="1" fill="#ffaa00"/><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="#ffaa00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      info: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" stroke="#2D5A3D" stroke-width="2" fill="none"/><path d="M12 16v-4" stroke="#2D5A3D" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="8" r="1" fill="#2D5A3D"/></svg>',
      remove: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" fill="none" stroke="#999" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };

    notification.style.cssText = `
      position: fixed; top: 100px; right: 20px; transform: translateX(100%);
      z-index: 10000; background: rgba(255, 255, 255, 0.95);
      color: #2d3436; padding: 16px 20px; border-radius: 12px;
      font-family: 'Jost', sans-serif; font-weight: 500; font-size: 1rem;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      max-width: 350px; min-width: 280px;
      border: 1px solid rgba(45, 90, 61, 0.2);
      backdrop-filter: blur(15px);
      -webkit-backdrop-filter: blur(15px);
    `;

    notification.innerHTML = `
      <div style="display: flex; align-items: center; gap: 1rem;">
        <div style="flex-shrink: 0;">
          ${icons[type]}
        </div>
        <span style="flex: 1; line-height: 1.5;">${message}</span>
      </div>
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);

    setTimeout(() => {
      if (notification && notification.parentElement) {
        notification.style.transform = 'translateX(100%)';
        notification.style.opacity = '0';
        setTimeout(() => {
          if (notification && notification.parentElement) {
            notification.remove();
          }
        }, 400);
      }
    }, 4000);
  }

  // CONTROLLA SE PRODOTTO È IN WISHLIST
  function checkWishlist(handle) {
    try {
      if (typeof window.isProductInWishlist === 'function') {
        return window.isProductInWishlist(handle);
      }

      const wishlist = localStorage.getItem('fx-wishlist');
      if (wishlist) {
        const wishlistData = JSON.parse(wishlist);
        return wishlistData.some(item => item.handle === handle);
      }
    } catch (error) {
    }
    return false;
  }

  // SALVA/RIMUOVI DA WISHLIST
  function toggleWishlistStorage(button, add) {
    try {
      const handle = button.dataset.productHandle;
      const title = button.dataset.productTitle;
      const url = button.dataset.productUrl;
      const image = button.dataset.productImage;
      const price = button.dataset.productPrice;

      let wishlist = [];
      const stored = localStorage.getItem('fx-wishlist');
      if (stored) {
        wishlist = JSON.parse(stored);
      }

      if (add) {
        wishlist.push({ handle, title, url, image, price });
      } else {
        wishlist = wishlist.filter(item => item.handle !== handle);
      }

      localStorage.setItem('fx-wishlist', JSON.stringify(wishlist));

      // Trigger evento
      window.dispatchEvent(new CustomEvent('fx-wishlist-updated', {
        detail: { wishlist, action: add ? 'add' : 'remove', handle }
      }));
    } catch (error) {
    }
  }

  // FUNZIONE GLOBALE PER GESTIRE WISHLIST
  window.handleWishlistToggle = function(button) {
    const handle = button.dataset.productHandle;
    const title = button.dataset.productTitle;
    const isActive = button.classList.contains('active');

    if (isActive) {
      // Rimuovi
      button.classList.remove('active');
      button.setAttribute('aria-label', 'Aggiungi alla wishlist');
      toggleWishlistStorage(button, false);
      showNotification(`${title} rimosso dalla wishlist`, 'remove');
    } else {
      // Aggiungi
      button.classList.add('active');
      button.setAttribute('aria-label', 'Rimuovi dalla wishlist');
      toggleWishlistStorage(button, true);
      showNotification(`${title} aggiunto alla wishlist`, 'success');
    }
  };

  // INIZIALIZZA WISHLIST
  function initWishlist() {
    const section = document.querySelector('.fx-recently-viewed-section');
    if (!section) return;

    const buttons = section.querySelectorAll('.fx-wishlist-btn:not([data-wishlist-initialized])');

    buttons.forEach(button => {
      button.setAttribute('data-wishlist-initialized', 'true');

      // Controlla se già in wishlist
      const handle = button.dataset.productHandle;
      if (checkWishlist(handle)) {
        button.classList.add('active');
        button.setAttribute('aria-label', 'Rimuovi dalla wishlist');
      }

      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.handleWishlistToggle(button);
      });
    });
  }

  // ASCOLTA AGGIORNAMENTI WISHLIST DA ALTRE SEZIONI
  window.addEventListener('fx-wishlist-updated', function(event) {
    const { handle, action } = event.detail;

    // Aggiorna tutti i pulsanti wishlist in questa sezione
    const section = document.querySelector('.fx-recently-viewed-section');
    if (!section) return;

    const buttons = section.querySelectorAll(`.fx-wishlist-btn[data-product-handle="${handle}"]`);
    buttons.forEach(button => {
      if (action === 'add') {
        button.classList.add('active');
        button.setAttribute('aria-label', 'Rimuovi dalla wishlist');
      } else if (action === 'remove') {
        button.classList.remove('active');
        button.setAttribute('aria-label', 'Aggiungi alla wishlist');
      }
    });

    // AGGIORNA CONTATORE HEADER WISHLIST
    if (typeof updateWishlistHeaderCounter === 'function') {
      updateWishlistHeaderCounter();
    }
  });

  // API PUBBLICA
  window.FXRecentlyViewed = {
    add: addProduct,
    remove: removeProduct,
    clear: clearAll,
    get: () => [...recentlyViewed],
    refresh: render
  };

  // INIT
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // PAGESHOW (back/forward cache)
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      loadFromStorage();
      render();
    }
  });
})();

// SCRIPT PER AGGIUNGERE /mq E +IVA AI PREZZI
(function() {
  // Funzione per verificare se è una piastrella
  function isTileProduct(productType, vendor, handle) {
    if (!productType && !vendor && !handle) return false;

    const type = (productType || '').toLowerCase();
    const vend = (vendor || '').toLowerCase();
    const hdl = (handle || '').toLowerCase();

    // Verifica tipo prodotto
    if (type) {
      if (type.includes('piastrelle') ||
          type.includes('piastrella') ||
          type.includes('tile') ||
          type.includes('tiles') ||
          type.includes('ceramica') ||
          type.includes('gres') ||
          type.includes('porcellanato')) {
        return true;
      }
    }

    // Verifica vendor
    if (vend) {
      if (vend.includes('ceramicaeuro') ||
          vend.includes('formaaquae') ||
          vend.includes('ceramica euro') ||
          vend.includes('forma aquae')) {
        return true;
      }
    }

    // Verifica handle
    if (hdl) {
      if (hdl.includes('piastrelle') ||
          hdl.includes('piastrella') ||
          hdl.includes('tile') ||
          hdl.includes('ceramica') ||
          hdl.includes('gres')) {
        return true;
      }
    }

    return false;
  }

  // Applica /mq ai prezzi e usa prezzi fissi se disponibili
  function applyPriceSuffixes() {
    const priceContainers = document.querySelectorAll('.fx-recently-viewed-section .fx-price-container');
    const fmt = v => new Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(v);

    priceContainers.forEach(container => {
      const productType = container.getAttribute('data-product-type');
      const vendor = container.getAttribute('data-product-vendor');
      const handle = container.getAttribute('data-product-handle');

      const isTile = isTileProduct(productType, vendor, handle);

      // Applica prezzi fissi al mq se disponibili
      const priceElement = container.querySelector('.fx-price');
      const compareElement = container.querySelector('.fx-original-price');
      const discountBadge = container.querySelector('.fx-discount-badge');
      const card = container.closest('.fx-recently-viewed-cell, .fx-product-standard-card');
      const title = card ? (card.querySelector('h5, .fx-product-title') || {}).textContent || '' : '';

      if (priceElement && window.getPrezzoMinimoM2 && title) {
        try {
          var fisso = window.getPrezzoMinimoM2(title);
          if (fisso) {
            // getPrezzoMinimoM2 restituisce centesimi, dividi per 100
            var prezzoEur = fisso.prezzo / 100;
            var compareEur = fisso.comparePrice / 100;
            priceElement.textContent = fmt(prezzoEur);
            if (compareElement && compareEur > prezzoEur) {
              compareElement.textContent = fmt(compareEur);
              compareElement.style.display = '';
              if (discountBadge) {
                discountBadge.textContent = '';
                discountBadge.style.display = '';
              }
            }
          }
        } catch(e) {}
      }

      // Aggiungi /mq al prezzo
      if (priceElement && !priceElement.querySelector('.fx-mq-suffix')) {
        let priceText = priceElement.textContent.trim().replace(/\+IVA/gi, '').replace(/\/mq/gi, '').trim();

        if (isTile) {
          priceElement.innerHTML = priceText +
            '<span class="fx-mq-suffix" style="font-size: 1em; color: inherit; font-weight: inherit;">/</span>' +
            '<span class="fx-mq-suffix" style="font-size: 0.9em; color: inherit;">mq</span>';
        }
      }
    });
  }

  // Esegui immediatamente
  applyPriceSuffixes();

  // Esegui anche dopo un breve delay per sicurezza
  setTimeout(applyPriceSuffixes, 100);

  // Esegui dopo ogni render
  window.addEventListener('fx-recently-viewed-rendered', applyPriceSuffixes);
})();
